import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useSessionStorage } from 'shared/hooks'

export default function useRecoverPasswordPath() {
  const [searchParams, setSearchParams] = useSearchParams()

  const fallbackPath = `${window.workflowExecutorSitemodel}?workflowmodelUuid=${window.recoverPasswordProcessmodelUuid}`

  const [recoverPasswordPath, setRecoverPasswordPath] = useSessionStorage(
    'recoverPasswordPath',
    fallbackPath
  )

  useEffect(() => {
    const recoverPasswordPathFromParams = searchParams.get(
      'recoverPasswordPath'
    )
    if (recoverPasswordPathFromParams) {
      setRecoverPasswordPath(recoverPasswordPathFromParams)
      searchParams.delete('recoverPasswordPath')
      setSearchParams(searchParams, { replace: true })
    }
  }, [searchParams, setRecoverPasswordPath, setSearchParams])

  return recoverPasswordPath
}
